import api from './api';
import type {
  ReferralOverview,
  ReferralCode,
  ReferralReward,
  ReferralAnalytics,
  LeaderboardEntry,
  AffiliateReport,
  AffiliatePayout,
} from '../types';

export const referralService = {
  async getOverview(): Promise<ReferralOverview> {
    const response = await api.get('/api/referrals/overview');
    return response.data;
  },

  async updateCode(payload: { code: string; expires_at?: string | null }): Promise<{ code: ReferralCode }> {
    const response = await api.post('/api/referrals/code', payload);
    return response.data;
  },

  async regenerateCode(): Promise<{ code: ReferralCode }> {
    const response = await api.post('/api/referrals/code/regenerate');
    return response.data;
  },

  async getTracking(params?: { status?: string; per_page?: number }) {
    const response = await api.get('/api/referrals/tracking', { params });
    return response.data;
  },

  async getRewards(params?: { per_page?: number }): Promise<{ data: ReferralReward[] }> {
    const response = await api.get('/api/referrals/rewards', { params });
    return response.data;
  },

  async getLeaderboard(period: 'monthly' | 'all_time' = 'all_time'): Promise<{ leaderboard: LeaderboardEntry[] }> {
    const response = await api.get('/api/referrals/leaderboard', { params: { period } });
    return response.data;
  },

  async getAnalytics(): Promise<{ analytics: ReferralAnalytics }> {
    const response = await api.get('/api/referrals/analytics');
    return response.data;
  },

  async invite(payload: { emails: string[]; message?: string; channel?: string }): Promise<{ tracking_pixel_url: string }> {
    const response = await api.post('/api/referrals/invite', payload);
    return response.data;
  },

  async getAffiliateReport(): Promise<{ report: AffiliateReport }> {
    const response = await api.get('/api/referrals/affiliate/report');
    return response.data;
  },

  async getAffiliatePayouts(params?: { per_page?: number }): Promise<{ data: AffiliatePayout[] }> {
    const response = await api.get('/api/referrals/affiliate/payouts', { params });
    return response.data;
  },

  async requestAffiliatePayout(payload: {
    amount: number;
    currency?: string;
    method?: 'paypal' | 'stripe';
    payout_details?: Record<string, unknown>;
    tax_form_status?: string;
    period_start?: string;
    period_end?: string;
  }): Promise<{ payout: AffiliatePayout }> {
    const response = await api.post('/api/referrals/affiliate/payouts', payload);
    return response.data;
  },
};

export default referralService;
